export default __webpack_public_path__ + "464c188b57a0ab9c5fead5d266cf7c27.png";